define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var ButtonDropdownViewController = require('web-agent-components/ButtonDropdownViewController');
    var NumericInputViewController = require('web-agent-viewControllers/NumericInputViewController');
    var BaseFilterItem = require('web-agent-components/BaseFilterItemViewController');
    var ViewController = require('web-agent-framework/ViewController');


    var DURATION_UNITS = {
        minutes: "minutes",
        hours: "hours",
        days: "days"
    };
    var COMPARISON_OPTIONS = {
        longer: "longer",
        between: "between",
        shorter: "shorter"
    };
    var DEFAULT_RANGE = {
        max: 999999,
        min: 0
    };
    var DEFAULT_AVAILABLE_DURATION_UNITS = [DURATION_UNITS.minutes];
    var DEFAULT_FILTER_OPTIONS = {
        comparisonMethod: COMPARISON_OPTIONS.longer,
        longerThan: 0,
        shorterThan: 1,
        durationUnit: DURATION_UNITS.minutes
    };
    var MIN_WIDTH = 170;


    var DurationInputViewController = BaseFilterItem.extend({
        ControllerName: 'DurationInputViewController',
        LPTemplatesFiles: {
            filterDurationInput: "LP_filter_duration_input.html"
        },
        LPViewMap: {
            rangeArea: ".lpview_rangeArea",
            comparisonMethod: ".lpview_comparison_method",
            dropDown: ".lpview_dropdown_anchor",
            firstInput: ".lpview_duration_first_input",
            secondInput: ".lpview_duration_second_input",
            andLabel: '.lpview_duration_and_label',
            unitLabel: '.lpview_duration_unit_label',
            unitInput: '.lpview_duration_unit_input'
        },
        LPClassesMap: {
            hidden: "hidden"
        },
        LPComparisonOptions: COMPARISON_OPTIONS,
        LPDurationUnits: DURATION_UNITS,

        initialize: function (constructorData) {

            // Component configuration with default fallback
            this.availableDurationUnits = constructorData.availableDurationUnits || DEFAULT_AVAILABLE_DURATION_UNITS;
            this.longerThanRange = constructorData.longerThanRange || DEFAULT_RANGE;
            this.shorterThanRange = constructorData.shorterThanRange || DEFAULT_RANGE;
            this.defaultFilter = constructorData.defaultFilter || DEFAULT_FILTER_OPTIONS;

            this.disableResize = !!constructorData.disableResize;
            this.minimumWidth = constructorData.minimumWidth || MIN_WIDTH;

            this.comparisonMethod = this.defaultFilter.comparisonMethod;
            this.longerThan = this.defaultFilter.longerThan;
            this.shorterThan = this.defaultFilter.shorterThan;
            this.durationUnit = this.defaultFilter.durationUnit;

            this.isSingleDurationMode = !!(this.availableDurationUnits && this.availableDurationUnits.length === 1);

            this.initializeView();
        },

        events: function () {
        },

        render: function () {
        }
    });

    /* *** Statics - Exporting out.  *** */
    DurationInputViewController.DURATION_UNITS = DURATION_UNITS;
    DurationInputViewController.COMPARISON_OPTIONS = COMPARISON_OPTIONS;

    /* *** prototype *** */
    DurationInputViewController.prototype.getDurationUnitOptions = function () {
        return [
            { type: this.LPDurationUnits.minutes, text: this.translate('filter_duration_unit_minutes') },
            { type: this.LPDurationUnits.hours, text: this.translate('filter_duration_unit_hours') },
            { type: this.LPDurationUnits.days, text: this.translate('filter_duration_unit_days') }
        ];
    };
    DurationInputViewController.prototype.onDurationUnitChanged = function (data) {
        if (data && data.rowData && data.rowData.type) {
            this.updateDurationUnit(data.rowData.type);
        }
    };

    DurationInputViewController.prototype.updateDurationUnit = function (durationUnit) {
        if (durationUnit && this.LPDurationUnits.hasOwnProperty(durationUnit)) {
            this.durationUnit = durationUnit;
        }
        this.durationUnitVC.setSelectedIndex(this.getDurationUnitIndex(this.durationUnit));

        if (!this.disableResize) {
            this.handleResize();
        }
    };

    DurationInputViewController.prototype.getDurationUnitIndex = function (durationUnit) {
        var durationUnits = this.getDurationUnitOptions();
        var result = 0;
        for (var index = 0; index < durationUnits.length; index++) {
            if (durationUnits[index].type === durationUnit) {
                result = index;
                break;
            }
        }
        return result;
    };

    DurationInputViewController.prototype.getComparisonOptions = function () {
        var items = [];
        items.push({ type: this.LPComparisonOptions.longer, text: this.translate('filter_duration_longer') });
        items.push({ type: this.LPComparisonOptions.between, text: this.translate('filter_duration_between') });
        items.push({ type: this.LPComparisonOptions.shorter, text: this.translate('filter_duration_shorter') });
        return items;
    };

    DurationInputViewController.prototype.onComparisonMethodChanged = function (data) {
        if (data && data.rowData && data.rowData.type) {
            this.updateComparisonMethod(data.rowData.type);
        }
    };

    DurationInputViewController.prototype.updateComparisonMethod = function (comparisonMethod) {
        if (!comparisonMethod || comparisonMethod === this.comparisonMethod) {
            return;
        }

        // update comparison value and method component
        this.comparisonMethod = comparisonMethod;
        this.comparisonMethodVC.setSelectedIndex(this.getComparisonIndex(this.comparisonMethod));

        // update the firstInput ranges
        var rangeType = this.comparisonMethod === this.LPComparisonOptions.shorter ? 'shorterThanRange' : 'longerThanRange';
        this.firstInputVC.setMaximumInputValue(this[rangeType].max);
        this.firstInputVC.setMinimumInputValue(this[rangeType].min);

        this._updateSecondInputIfNeeded();
        this._updateViewByCurrentComparisonMethod();
    };

    DurationInputViewController.prototype.getValue = function () {
        var firstInput = this.firstInputVC.currentInputValue;
        var secondInput = this.secondInputVC.currentInputValue;
        if (!_.isNumber(firstInput)) {
            return;
        }
        var result = {
            comparisonMethod: this.comparisonMethod,
            durationUnit: this.durationUnit
        };
        switch (this.comparisonMethod) {
            case this.LPComparisonOptions.between:
                if (!_.isNumber(secondInput)) {
                    return;
                }
                this.longerThan = firstInput;
                this.shorterThan = secondInput;
                result.shorterThan = this.shorterThan;
                result.longerThan = this.longerThan;
                break;
            case this.LPComparisonOptions.shorter:
                this.shorterThan = firstInput;
                result.shorterThan = this.shorterThan;
                break;
            case this.LPComparisonOptions.longer:
                this.longerThan = firstInput;
                result.longerThan = this.longerThan;
                break;
            default:
                break;
        }

        return result;
    };

    DurationInputViewController.prototype.getComparisonIndex = function (comparisonMethod) {
        var comparisonOptions = this.getComparisonOptions();
        var result = 0;
        for (var index = 0; index < comparisonOptions.length; index++) {
            if (comparisonOptions[index].type === comparisonMethod) {
                result = index;
                break;
            }
        }
        return result;
    };

    DurationInputViewController.prototype.initializeView = function () {
        var filterTemplate = require("web-agent-templates/" + this.LPTemplatesFiles.filterDurationInput);
        var durationObj = this.getDurationUnitOptions()[this.getDurationUnitIndex(this.durationUnit)];

        var textInjection = {
            unitLabel: durationObj.text
        };
        filterTemplate = this.injectTextDefaults(filterTemplate, textInjection);
        this.createView({ template: filterTemplate });

        this.comparisonMethodVC = new ButtonDropdownViewController({
            items: this.getComparisonOptions(),
            selectedIndex: this.getComparisonIndex(this.comparisonMethod),
            context: this,
            itemClicked: this.onComparisonMethodChanged,
            textProperty: "text"
        });
        this.addViewController({
            viewController: this.comparisonMethodVC,
            target: this.LPViewMap.comparisonMethod
        });

        var firstInputConfig = {
            valueChangedCallback: this.onFirstInputChanged.bind(this),
            lostFocusCallback: this._onFocusChanged.bind(this, 'first'),
            context: this
        };
        if (this.comparisonMethod === this.LPComparisonOptions.shorter) {
            firstInputConfig.defaultInputValue = this.shorterThan;
            firstInputConfig.minimumInputValue = this.shorterThanRange.min;
            firstInputConfig.maximumInputValue = this.shorterThanRange.max;
        } else {
            firstInputConfig.defaultInputValue = this.longerThan;
            firstInputConfig.minimumInputValue = this.longerThanRange.min;
            firstInputConfig.maximumInputValue = this.longerThanRange.max;
        }
        this.firstInputVC = new NumericInputViewController(firstInputConfig);
        this.addViewController({ viewController: this.firstInputVC, target: this.LPViewMap.firstInput });

        var secondInputConfig = {
            inputElement: this.LPViewMap.shorterThanInput,
            defaultInputValue: this.shorterThan,
            minimumInputValue: this.shorterThanRange.min,
            maximumInputValue: this.shorterThanRange.max,
            valueChangedCallback: this.onSecondInputChanged.bind(this),
            lostFocusCallback: this._onFocusChanged.bind(this, 'second'),
            context: this
        };
        this.secondInputVC = new NumericInputViewController(secondInputConfig);
        this.addViewController({ viewController: this.secondInputVC, target: this.LPViewMap.secondInput });

        if (!this.isSingleDurationMode) {
            this.durationUnitVC = new ButtonDropdownViewController({
                items: this.getDurationUnitOptions(),
                selectedIndex: this.getDurationUnitIndex(this.durationUnit),
                context: this,
                itemClicked: this.onDurationUnitChanged,
                textProperty: "text"
            });
            this.addViewController({ viewController: this.durationUnitVC, target: this.LPViewMap.unitInput });
            ViewController.prototype.lpHide(this.LPViewMap.unitLabel, this.view);
        } else {
            ViewController.prototype.lpHide(this.LPViewMap.unitInput, this.view);
        }

        this.firstInputVC.updateCurrentInputValue();
        this.secondInputVC.updateCurrentInputValue();

        // sets the default values and renders the view
        this.setValue();
    };

    /**
     * Callback for numeric field focus change
     * @param {String} value
     * @private
     */
    DurationInputViewController.prototype._onFocusChanged = function (target, event) {
        if (event.target.value === "") {
            if (target === 'first'){
                this.firstInputVC.setCurrentValue('');
            } else {
                this.secondInputVC.setCurrentValue('');
            }
        }
    };

    DurationInputViewController.prototype.onFirstInputChanged = function (value) {
        var input = _.isNumber(value) ? value : '';
        this.firstInputVC.setCurrentInputValue(input);

        this._updateSecondInputIfNeeded();
    };

    DurationInputViewController.prototype._updateSecondInputIfNeeded = function () {
        var firstInput = this.firstInputVC.currentInputValue;
        var secondInput = this.secondInputVC.currentInputValue;
        if (this.comparisonMethod === this.LPComparisonOptions.between && secondInput <= firstInput) {
            if (firstInput + 1 <= this.shorterThanRange.max && firstInput + 1 >= this.shorterThanRange.min) {
                this.secondInputVC.setCurrentInputValue(firstInput + 1);
            }
            else {
                this.firstInputVC.setCurrentValue(this.defaultFilter.longerThan);
            }
        }
    };


    DurationInputViewController.prototype.onSecondInputChanged = function (value) {
        var input = _.isNumber(value) ? value : '';
        this.secondInputVC.setCurrentInputValue(input);

        if (_.isNumber(input) && this.comparisonMethod === this.LPComparisonOptions.between &&
            this.firstInputVC.currentInputValue >= input) {
            if (input - 1 >= this.longerThanRange.min && input - 1 <= this.longerThanRange.max) {
                this.firstInputVC.setCurrentInputValue(input - 1);
            }
            else {
                this.secondInputVC.setCurrentValue(this.defaultFilter.shorterThan);
            }
        }
    };

    DurationInputViewController.prototype.setValue = function (filterUIData) {
        var filterData = lpUtils.cloneObject(filterUIData || this.defaultFilter);
        this.shorterThan = _.isNumber(filterData.shorterThan) ? filterData.shorterThan : '';
        this.longerThan = _.isNumber(filterData.longerThan) ? filterData.longerThan : '';
        this.comparisonMethod = filterData.comparisonMethod;
        if (!this.isSingleDurationMode) {
            this.durationUnit = filterData.durationUnit;
        }

        this.render();
    };

    // set the display elements to the data in the filter
    DurationInputViewController.prototype.render = function () {
        // update duration
        if (!this.isSingleDurationMode) {
            this.durationUnitVC.setSelectedIndex(this.getDurationUnitIndex(this.durationUnit));
        }

        // update comparison method
        this.comparisonMethodVC.setSelectedIndex(this.getComparisonIndex(this.comparisonMethod));

        // update first and second input
        if (this.comparisonMethod === this.LPComparisonOptions.shorter) {
            this.firstInputVC.setCurrentValue(this.shorterThan);
        } else if (this.comparisonMethod === this.LPComparisonOptions.longer) {
            this.firstInputVC.setCurrentValue(this.longerThan);
        } else {
            this.firstInputVC.setCurrentValue(this.longerThan);
            this.secondInputVC.setCurrentValue(this.shorterThan);
        }

        this._updateViewByCurrentComparisonMethod();
    };

    DurationInputViewController.prototype._updateViewByCurrentComparisonMethod = function () {
        switch (this.comparisonMethod) {
            case this.LPComparisonOptions.between:
                this.removeClass(this.LPViewMap.firstInput, this.LPClassesMap.hidden);
                this.removeClass(this.LPViewMap.secondInput, this.LPClassesMap.hidden);
                this.removeClass(this.LPViewMap.andLabel, this.LPClassesMap.hidden);
                break;
            case this.LPComparisonOptions.longer:
            case this.LPComparisonOptions.shorter:
                this.removeClass(this.LPViewMap.firstInput, this.LPClassesMap.hidden);
                this.addClass(this.LPViewMap.secondInput, this.LPClassesMap.hidden);
                this.addClass(this.LPViewMap.andLabel, this.LPClassesMap.hidden);
                break;
        }
        if (!this.disableResize) {
            this.handleResize();
        }
    };

    DurationInputViewController.prototype.handleResize = function () {
        var elements = {
            durationUnit: this.isSingleDurationMode ? this.getFirstElement(this.LPViewMap.unitLabel) : this.getFirstElement(this.LPViewMap.unitInput),
            firstInput: this.getFirstElement(this.LPViewMap.firstInput),
            secondInput: this.getFirstElement(this.LPViewMap.secondInput),
            andLabel: this.getFirstElement(this.LPViewMap.andLabel),
            mainDiv: this.getFirstElement(this.LPViewMap.main_div)
        };

        var durationElementWidth = elements.durationUnit.offsetWidth;
        var inputTotalWidth = elements.firstInput.offsetWidth + elements.secondInput.offsetWidth;
        var labelWidth = elements.andLabel.offsetWidth;

        var widgetWidth = inputTotalWidth + labelWidth + durationElementWidth;

        if (widgetWidth && widgetWidth < this.minimumWidth) {
            widgetWidth = this.minimumWidth;
        }

        var comparisonDropDown = this.comparisonMethodVC.getFirstElement(this.LPViewMap.dropDown);
        var dropDownPadding = this.getComputedStyle(comparisonDropDown, 'padding-left', 10) + this.getComputedStyle(comparisonDropDown, 'padding-right', 10);
        var dropDownBorder = this.getComputedStyle(comparisonDropDown, 'border-left', 10) + this.getComputedStyle(comparisonDropDown, 'border-right', 10);
        var comparisonDropDownWidth = widgetWidth - dropDownPadding - dropDownBorder;

        // enlarge the duration unit to fill the space
        var durationUnitWidth = (this.isSingleDurationMode ? comparisonDropDownWidth : widgetWidth) - inputTotalWidth - labelWidth;
        this.setStyle(elements.durationUnit, { width: durationUnitWidth + "px" });
        this.setStyle(elements.mainDiv, { width: widgetWidth + "px" });
        this.setStyle(comparisonDropDown, { width: comparisonDropDownWidth + "px" });
    };


    return DurationInputViewController;

});
